import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const NavigationControls = ({ currentSlide, totalSlides, onPrev, onNext }) => {
  return (
    <>
      <button
        data-testid="nav-prev-btn"
        className="nav-button prev"
        onClick={onPrev}
        disabled={currentSlide === 0}
        aria-label="Previous slide"
      >
        <ChevronLeft />
      </button>
      
      <button
        data-testid="nav-next-btn"
        className="nav-button next"
        onClick={onNext}
        disabled={currentSlide === totalSlides - 1}
        aria-label="Next slide"
      >
        <ChevronRight />
      </button>
    </>
  );
};

export default NavigationControls;
